import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=bfefd432&scoped=true&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySpinner.vue?vue&type=style&index=0&id=bfefd432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefd432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VLayout,VProgressCircular,VSnackbar})
